import Skeleton from '@mui/material/Skeleton';
import { Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { MainContainer } from '../../style/GlobalStyles';
import React from 'react';

export const skeleton = (
    <>
        <MainContainer>
            <Box
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'center'}
                sx={{
                    width: '100%',
                    '@media (max-width:425px)': {
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',

                        '& button': {
                            marginTop: '1rem',
                        },
                    },
                }}
            >
                <Skeleton
                    variant="text"
                    height={'2rem'}
                    sx={{
                        width: { xs: '50%', sm: '15%' },
                    }}
                />
                <Skeleton variant="rectangular" width={175} height={40} sx={{ borderRadius: '0.3rem', marginTop: '0.5rem' }} />
            </Box>
            <Box marginTop={'3rem'}>
                <Typography component={'h2'} fontSize={'customFontSize.large'} lineHeight={'140%'} marginBottom={{ xs: '2rem', sm: '2rem' }}>
                    <Skeleton
                        variant="text"
                        sx={{
                            width: { xs: '40%', sm: '10%' },
                        }}
                    />
                </Typography>

                {/* Table UI */}
                <TableContainer
                    sx={{
                        display: {
                            xs: 'none',
                            sm: 'block',
                        },
                    }}
                >
                    <Table
                        sx={{
                            minWidth: 600,

                            '& .MuiTableCell-root': {
                                borderBottom: 'unset',
                                padding: '4px 32px',
                                // minWidth:"200px",
                                // width: 350,

                                '&[colspan]': {
                                    padding: '0',
                                },
                            },
                        }}
                    >
                        <TableBody>
                            {Array.from(Array(3).keys()).map((key) => (
                                <>
                                    <TableRow>
                                        <TableCell
                                            colSpan={4}
                                            sx={{
                                                paddingLeft: 0,
                                            }}
                                        >
                                            <Typography component={'h2'} fontSize={'customFontSize.large'} fontWeight={'fontWeightSemiBold'} marginBottom={'0.8rem'} marginTop={'1.5rem'}>
                                                <Skeleton
                                                    variant="text"
                                                    sx={{
                                                        width: { xs: '40%', sm: '15%' },
                                                    }}
                                                />
                                            </Typography>
                                        </TableCell>
                                    </TableRow>

                                    {Array.from(Array(2).keys())?.map((cListItemDetails) => (
                                        <TableRow
                                            sx={{
                                                '&:last-child td, &:last-child th': { border: 0 },
                                            }}
                                        >
                                            <TableCell align="start" width={'25%'}>
                                                <Typography fontSize={'customFontSize.small'}>
                                                    <Skeleton variant="text" width="30%" sx={{ minWidth: '20%' }} />
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="start" width={'25%'}>
                                                <Typography fontSize={'customFontSize.small'}>
                                                    <Skeleton variant="text" width="30%" sx={{ minWidth: '20%' }} />
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="start" width={'25%'}>
                                                <Typography fontSize={'customFontSize.small'}>
                                                    <Skeleton variant="text" width="80%" sx={{ minWidth: '20%' }} />
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="start" width={'25%'}>
                                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width={'100%'}>
                                                    <Skeleton variant="rectangular" width={25} height={16} sx={{ borderRadius: '4px', minWidth: 25 }} />

                                                    <Typography width={'50%'} marginLeft={'0.5rem'} marginRight={'1.5rem'} sx={{ minWidth: '20%' }}>
                                                        <Skeleton variant="text" width="100%" />
                                                    </Typography>
                                                    <Skeleton variant="text" width={48} height={24} sx={{ minWidth: 48 }} />
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* List UI for mobile view */}
                <Box
                    component={'ul'}
                    sx={{
                        listStyleType: 'none',

                        display: { sm: 'none', xs: 'block' },
                    }}
                >
                    {Array.from(Array(5).keys()).map((id) => (
                        <Box
                            key={id}
                            component={'li'}
                            sx={(theme) => ({
                                borderRadius: theme.typography.borderRadius.xxSmall,
                                border: `1px solid ${theme.palette.grey[300]}`,
                                background: theme.palette.background.paper,

                                padding: `${theme.typography.generic.medium} ${theme.typography.generic.large}`,
                                width: '100%',

                                marginBottom: theme.typography.generic.xLarge,

                                display: 'flex',
                                flexDirection: 'column',

                                gap: '0.725rem',
                            })}
                        >
                            {Array.from(Array(4).keys()).map((id) => (
                                <Box key={id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Skeleton variant="text" sx={{ height: '1.5rem', width: '35%', minWidth: '1.5rem', maxWidth: '45%' }} />
                                    <Skeleton variant="text" sx={{ height: '1.5rem', width: '35%', minWidth: '1.5rem', maxWidth: '45%' }} />
                                </Box>
                            ))}

                            <Box
                                sx={(theme) => ({
                                    width: '100%',
                                    marginTop: '0.25rem',
                                    paddingTop: '0.25rem',
                                    borderTop: `1px solid ${theme.palette.grey[300]}`,

                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                })}
                            >
                                <Skeleton variant="text" sx={{ height: '1.5rem', width: '35%', minWidth: '1.5rem', maxWidth: '45%' }} />
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>

            <Box marginTop={'3rem'} paddingBottom={'1rem'} display={'flex'} flexDirection={'column'} justifyContent={'start'} alignItems={'start'}>
                <Skeleton variant="text" width={210} height={25} />
                <Skeleton variant="text" width={210} height={25} />
            </Box>
        </MainContainer>
    </>
);

export const updatePaymentSkeleton = (
    <Box>
        <Typography component={'h2'} color={'text.primary'} textAlign={'start'} fontSize={'customFontSize.medium'} fontWeight={'fontWeightSemiBold'} lineHeight={'normal'} marginBottom={'0.8rem'}>
        <Skeleton variant="text" sx={{ fontSize: '1rem',width:{
            xs:'30%',
            sm:"40%"
        } }} />
        </Typography>

        <List
            sx={{
                '& .MuiListItem-root': {
                    // padding: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                },

                '& .MuiButtonBase-root.MuiListItemButton-root': {
                    border: '1px solid #EAECF0',
                    borderRadius: '8px',
                    padding: '1rem',

                    display: 'flex',
                    alignItems: 'flex-start',

                    '&.Mui-selected': {
                        border: '1px solid #014DE5',
                    },
                },

                '& .MuiListItemSecondaryAction-root': {
                    top: '30px',
                    transform: 'translateY(-20%)',
                },

                '& .MuiAvatar-root': {
                    borderRadius: '10px',
                    height: '40px',
                    width: '45px',
                },

                '& .MuiListItemText-root': {
                    margin: 0,
                },
            }}
        >
            {Array.from(Array(2).keys()).map((cCardDetails) => (
                <ListItem alignItems="center" secondaryAction={<Skeleton variant="circular" width={16} height={16} />}>
                    <ListItemButton>
                        <ListItemAvatar sx={{marginTop:"0.2rem"}}>
                            <Skeleton variant="rectangular" width={40} height={30} sx={{borderRadius:"4px"}} />
                        </ListItemAvatar>
                        <ListItemText
                            primary={  <Skeleton variant="text" sx={{ fontSize: '1rem',width:{
                                xs:'40%',
                                sm:"40%"
                            } }} />}
                            secondary={
                                <React.Fragment>
                                    <Typography component="span" variant="body2" sx={{ color: cCardDetails.ccExpiringSoon ? 'red' : 'text.primary', display: 'inline' }}>
                                        <Skeleton variant="text" sx={{ fontSize: '1rem' ,width:{
                                            xs:'50%',
                                            sm:"50%"
                                        }}} />
                                    </Typography>
                                </React.Fragment>
                            }
                        />
                    </ListItemButton>
                </ListItem>
            ))}
        </List>
            <Skeleton variant="text" width={210} height={25} />
    </Box>
);
